import { createSelector } from 'reselect'
import { getViewedOrder } from 'selectors/orderSelectors'
import { getRegionByCode } from '@luxuryescapes/lib-regions'

/**
 * Sums the price of all international accommodation items in an order.
 * Used to determine Taste of Gold eligibility for post-purchase benefit redemption.
 */
const getOrderInternationalItemsTotal = createSelector(
  (state: App.State) => getViewedOrder(state),
  (existingOrder): number => {
    if (!existingOrder) return 0

    const orderRegion = getRegionByCode(existingOrder.regionCode)
    if (!orderRegion) return 0

    const orderRegionCode = orderRegion.code.toLowerCase()
    const orderRegionName = orderRegion.name.toLowerCase()

    let total = 0

    for (const item of existingOrder.bedbankItems) {
      const countryCode = item.offer?.property?.address?.countryCode
      if (countryCode && countryCode.toLowerCase() !== orderRegionCode) {
        total += item.total
      }
    }

    for (const item of existingOrder.tourItems) {
      const hasInternationalDeparture = item.tour.countriesVisited.some(
        countryName => countryName.toLowerCase() !== orderRegionName,
      )
      if (hasInternationalDeparture) {
        total += item.total
      }
    }

    for (const item of existingOrder.items) {
      const countryCode = item.offer.property?.geoData?.countryCode
      if (countryCode && countryCode.toLowerCase() !== orderRegionCode) {
        total += item.total
      }
    }

    return total
  },
)

export default getOrderInternationalItemsTotal
